<template>
    <div class="tw-ws-title" :style="{position: 'absolute', fontSize: `${fontSize}px`, color: fontColor}">
        <div v-if="move" class="inner-container" :style="{animation: `twWsTitleMove ${cycle}s linear infinite`, width: (actualWidth==0?'100%':actualWidth+'px')}">
            <div :ref="innerRef" style="width: 100%;">
                <span :ref="spanRef">{{title}}</span>
            </div>
        </div>
        <div class="nomove" v-else>{{title}}</div>
    </div>
</template>

<script>
import { ref, nextTick } from 'vue'

export default {
    name: 'tw-ws-title',
    setup(){
        let innerWidth;
        let spanWidth;
        var actualWidth = ref(0);

        const innerRef = el => {
            innerWidth = el;
        }
        const spanRef = el => {
            spanWidth = el;
        }

        nextTick(() => {
            actualWidth.value = 0;
            if(innerRef && spanRef){
                if(innerWidth && spanWidth && innerWidth.offsetWidth > 0 && spanWidth.offsetWidth > 0){
                    actualWidth.value = innerWidth.offsetWidth + spanWidth.offsetWidth;
                }
            }
        })

        return {
            innerRef,
            spanRef,
            actualWidth
        }
    },
    props: {
        title: {
            type: String,
            default: "请输入标题内容"
        },
        move: {
            type: Boolean,
            default: true
        },
        cycle: {
            type: Number,
            default: 10
        },
        fontSize: {
            type: Number,
            default: 25
        },
        fontColor: {
            type: String,
            default: '#FFFFFF'
        },
    }
}
</script>

<style>
</style>
